import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-white">
      <Seo title="Sayfa Bulunamadı | Mahallebi" path="/404" noindex />
      <h1 className="absolute bottom-0 text-6xl sm:text-8xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6 text-[#111827]">
          Aradığınız sayfa bulunamadı
        </h1>
        <p className="mt-4 text-base text-gray-500">
          Sayfa taşınmış veya kaldırılmış olabilir.
        </p>
        <Link
          to="/"
          className="inline-flex items-center mt-8 px-6 py-3 bg-[#e77e23] text-white font-semibold rounded-lg hover:bg-[#d35400] transition-colors"
        >
          Ana Sayfaya Dön
        </Link>
      </div>
    </div>
  );
}
